<mat-card>
  <mat-card-header>
    <h1>Account security</h1>
  </mat-card-header>

  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Login credentials">
        <p>This is how you currently login to risr/apply. Make sure you can always access your account by keeping this information up to date.</p>

        @for (loginCredential of loginCredentials; track loginCredential) {
          <div class="list-item">
            <div>
              <p>{{ readableName[loginCredential.type] }}</p>
              <p><strong>{{ loginCredential.username }}</strong></p>
              @if (loginCredential.passwordNotSet) {
                <p class="label label-warning">
                  A welcome email will be sent to guide the user through the setup process
                </p>
              }
            </div>
            <ul class="list-inline list-unstyled">
              @if (canAccessTwoFactorAuth(loginCredential.type)) {
                <li>
                  <a mat-flat-button color="accent" [routerLink]="[loginCredential.username, 'mfas']" [attr.aria-label]="'Two factor authentication for ' + loginCredential.username">
                    Two Factor Authentication
                  </a>
                </li>
              }
              @if (canUpdateUsername(loginCredential.type)) {
                <li><button mat-flat-button color="accent" (click)="updateUsername(loginCredential)" [attr.aria-label]="'Edit username for ' + loginCredential.username">Edit username</button></li>
              }
              @if (canUpdateSSOID(loginCredential.type)) {
                <li><button mat-flat-button color="accent" (click)="updateUsername(loginCredential)" [attr.aria-label]="'Edit SSO ID for ' + loginCredential.username">Edit SSO ID</button></li>
              }
              @if (canSendPasswordEmail(loginCredential.type)) {
                <li><button mat-flat-button color="accent" (click)="sendPasswordEmail(loginCredential)" [attr.aria-label]="'Send password reset email for ' + loginCredential.username">Send password reset email</button></li>
              }
              @if (canUpdatePassword(loginCredential.type)) {
                <li><button mat-flat-button color="accent" (click)="updatePassword(loginCredential)" [attr.aria-label]="'Change password for ' + loginCredential.username">Change password</button></li>
              }
              @if (canDelete()) {
                <li><button mat-flat-button color="warn" (click)="deleteCredential(loginCredential)" [attr.aria-label]="'Remove ' + loginCredential.username">Remove</button></li>
              }
            </ul>
          </div>
        }

        <div class="mt-4 mb-4">
          <ul class="list-inline list-unstyled">
            @for (type of allowedAccountTypes; track type) {
              <li>
                @if (canCreateCredential(type)) {
                  <button class="mr-2" mat-flat-button color="primary" (click)="addLoginCredential(type)">Add {{ readableName[type] }} Credential</button>
                }
              </li>
            }
          </ul>
        </div>
      </mat-tab>

      @if (canAccessAPIKeys()) {
        <mat-tab label="API keys">
          @if (newlyCreatedAPICredential) {
            <div class="box box-warn">
              <p>
                <strong>Warning!</strong> Make sure you copy the API credentials below. You won't be able to see them again!
              </p>
            </div>
          }
          @if (newlyCreatedAPICredential) {
            <div class="copy-text__container">
              <ul class="list-unstyled copy-text__text">
                <li>public_key: {{newlyCreatedAPICredential.public_key}}</li>
                <li>secret_key: {{newlyCreatedAPICredential.secret_key}}</li>
              </ul>
              <button mat-stroked-button (click)="copyToClipboard()">Copy</button>
            </div>
          }
          @for (apiCredential of apiCredentials; track apiCredential) {
            <div class="list-item">
              <div>
                <p>{{ readableName[apiCredential.type] }}</p>
                <p><strong>{{ apiCredential.public_key }}</strong></p>
              </div>
              <div>
                <button mat-flat-button color="warn" class="btn btn-sm btn-danger" (click)="deleteCredential(apiCredential)" [attr.aria-label]="'Remove ' + apiCredential.public_key">Remove</button>
              </div>
            </div>
          }
          <div class="mt-4 mb-4">
            <p>@if (canCreateCredential(CredentialTypes.API)) {
              <button mat-flat-button color="primary" (click)="createApiCredential()">Add API credential</button>
            }</p>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </mat-card-content>
</mat-card>
